import { flushSync } from 'react-dom'

/**
 * Property-panel text fields (DraftTextField / Synonym) keep the typed value
 * in a local draft until blur. ⌘S and the Save chip both fire while the
 * input is still focused.
 *
 * DesignerPage property setters run inside a React useState updater and then
 * queue updateNodePatch on a *second* microtask. One `queueMicrotask` after
 * blur is the React render, not the tree write — save would persist the old
 * synonym. flushSync commits the draft; two microtasks later the patch lands.
 */
export async function flushDesignerPropertyDrafts(): Promise<void> {
  const el = document.activeElement
  if (el instanceof HTMLElement && el !== document.body) {
    flushSync(() => {
      el.blur()
    })
  }
  await new Promise<void>((resolve) => {
    queueMicrotask(() => {
      queueMicrotask(resolve)
    })
  })
}
